// Vendor Libs
import React from 'react';

export const LayoutContext = React.createContext({
  clipped: undefined,
  collapsed: undefined,
  collapsedWidth: undefined,
  collapsible: undefined,
  footerShrink: undefined,
  headerPosition: undefined,
  navAnchor: undefined,
  navVariant: undefined,
  navWidth: undefined,
  open: undefined,
  setCollapsed: undefined,
  setOpen: undefined,
  squeezed: undefined,
});
